import { render, staticRenderFns } from "./DocumentDialog.vue?vue&type=template&id=4836e1ab&scoped=true"
import script from "./DocumentDialog.vue?vue&type=script&lang=js"
export * from "./DocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentDialog.vue?vue&type=style&index=0&id=4836e1ab&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4836e1ab",
  null
  
)

export default component.exports